export default __webpack_public_path__ + "static/media/family6.ec4f08d2.svg";